export const environment = {
  production: true,
  captchaInUse: false,
  rootToLoginOnRefresh: true,
  storeDataInSessionForDev: false,
  amplitudeKey: '466c65f4d91aac17e194b931fa0ac19d'
};
